import React from 'react';

import './tabLink.scss';

interface TabLinkProps {
    title: string;
    isActive?: boolean;
}

/**
 * Renders a component that looks like an Antd Tab.
 * We use this to simulate tabs whilst actually using different pages in the router.
 * This is an essential change as currently router navigation is not available for some tabs, e.g. refreshing cached video takes
 * you to video search.
 * @param title the user facing text
 * @param isActive defaults to false
 */
const TabLink: React.FC<TabLinkProps> = ({
    title,
    isActive = false,
}) => {
    return (
        <div 
            className='tab-link'
            style={{
                borderBottom: isActive ? '2px solid var(--safety-orange)' : 'none',
                color: isActive ? 'var(--safety-orange)' : 'var(--cool-gray-60)',
            }}
        >
            {title}
        </div>
    );
}

export default TabLink;